<template>
  <b-form-group
    label="Ürün Markası"
    label-for="id_brands"
  >
    <validation-provider
      #default="{ errors }"
      name="Ürün Markası"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_brands"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProductsBrandSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['brands/dataList']
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('brands/getDataList', {
        select: {
          id: true,
          title: true,
        },
      })
    },
  },
}
</script>
